import { forwardRef, memo, type ReactNode, type Ref, useRef } from 'react';
import { FormDropdown } from '~/commonComponents/FormDropdown';
import { DropdownOption } from '~/commonComponents/FormDropdown/DropdownOption';
import { factoryTimeOptions } from '~/commonComponents/InputJob/Hours/Utils';
import { useScrollIntoView } from '~/hooks/useScrollIntoView';

const TIME_OPTIONS = factoryTimeOptions();

interface IDepartureTimeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  isOpen: boolean;
  onToggle: () => void;
  labelRight?: ReactNode;
}

const Component = (
  { value, onChange, isOpen, onToggle, labelRight }: IDepartureTimeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const selectedRef = useRef<HTMLDivElement>(null);
  useScrollIntoView(selectedRef, isOpen);

  return (
    <div ref={ref}>
      <FormDropdown
        label="Departure"
        labelRight={labelRight}
        value={value}
        isOpen={isOpen}
        onToggle={onToggle}
        testId="departure-time-field"
      >
        {TIME_OPTIONS.map((option) => {
          const isSelected = value === option.value;
          return (
            <div key={option.value} ref={isSelected ? selectedRef : undefined}>
              <DropdownOption
                isSelected={isSelected}
                onSelect={() => {
                  onChange?.(option.value);
                  onToggle();
                }}
                testId={`time-option-${option.value}`}
              >
                {option.title}
              </DropdownOption>
            </div>
          );
        })}
      </FormDropdown>
    </div>
  );
};

export const DepartureTimeField = memo(forwardRef(Component));
